(function () {
    "user strict";

    angular
        .module("PWAPoCApp")
        .controller(
            "SelectSludgeContainerModalController",
            selectSludgeContainerModalController
        );

    selectSludgeContainerModalController.$inject = [
        "$scope",
        "$windowInstance",
        "units",
        "translateService",
    ];

    function selectSludgeContainerModalController(
        $scope,
        $windowInstance,
        units,
        translateService
    ) {
        $scope.units = units;
        $scope.selectedUnit = null;

        $scope.ok = function () {
            if ($scope.selectedUnit) {
                $windowInstance.close($scope.selectedUnit);
            } else {
                alert(
                    translateService.translate(
                        "routeStopCard.selectSludgeContainerModal.selectUnitAlert"
                    )
                );
            }
        };

        $scope.cancel = function () {
            $windowInstance.dismiss("cancel");
        };
    }
})();
